import { useCall } from "@/hooks/useCall/useCall";
import { useCallDurationRule } from "@/hooks/useCallDurationRule/useCallDurationRule";

export function useHeaderRules() {
  const { isCallDurationLow } = useCallDurationRule();
  const { call } = useCall();

  const shouldDisplayInfoBanner =
    isCallDurationLow && call?.type !== "voicemail";

  return {
    shouldDisplayInfoBanner,
  };
}
